import { loadStripe } from '@stripe/stripe-js';
import type { BloodEvaluationIntake } from './bloodPartnership';

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''
);

export async function startBloodEvaluationCheckout(
  intake: BloodEvaluationIntake
): Promise<void> {
  const response = await fetch('/.netlify/functions/create-blood-evaluation-checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(intake),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(
      typeof data.error === 'string' ? data.error : 'Could not start checkout'
    );
  }

  const { sessionId } = (await response.json()) as { sessionId: string };
  const stripe = await stripePromise;
  if (!stripe) throw new Error('Stripe failed to load');

  const result = await stripe.redirectToCheckout({ sessionId });
  if (result.error) {
    throw new Error(result.error.message);
  }
}
